
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import {createBootstrap} from 'bootstrap-vue-next';
import ToolTipDirective from './components/ToolTipDirective.js';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

import "admin-lte/dist/css/adminlte.min.css";
import "admin-lte/dist/js/adminlte";
import "bootstrap/dist/js/bootstrap.bundle";

import "./scss/index";


const app  = createApp(App);


app.use(createBootstrap())
app.use(router)

app.directive('tooltip', ToolTipDirective());
app.mount('#app')
